import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:4000';

const CreatorSetup = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSetup = async (e) => {
        e.preventDefault();
        setError('');

        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        if (password.length < 8) {
            setError('Password must be at least 8 characters');
            return;
        }

        setLoading(true);

        try {
            const res = await fetch(`${API_BASE}/api/auth/creator-setup`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password })
            });

            const data = await res.json();

            if (res.ok) {
                // Auto login on success
                localStorage.setItem('paradise_token', data.token);
                localStorage.setItem('paradise_user', JSON.stringify(data.user));
                navigate('/creator/handbook');
            } else {
                setError(data.message || 'Setup failed');
            }
        } catch (err) {
            console.error(err);
            setError('Connection error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#f4f4f0] flex items-center justify-center p-4 font-mono text-sm">
            <div className="w-full max-w-md">
                <div className="mb-8 text-center">
                    <h1 className="text-2xl font-bold uppercase tracking-widest mb-2">Account Setup</h1>
                    <p className="text-gray-500 text-xs uppercase tracking-wide">Initialize Creator Access</p>
                </div>

                <div className="bg-white p-8 rounded shadow-lg border border-gray-200">
                    <form onSubmit={handleSetup} className="space-y-6">
                        <div>
                            <label className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2">Approved Email</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full bg-gray-50 border border-gray-200 p-3 outline-none focus:border-black transition-colors font-mono"
                                placeholder="name@example.com"
                                required
                            />
                            <p className="mt-1 text-[10px] text-gray-400">Must match your approved application email.</p>
                        </div>

                        <div>
                            <label className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2">Set Password</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full bg-gray-50 border border-gray-200 p-3 outline-none focus:border-black transition-colors font-mono"
                                required
                            />
                            <p className="mt-1 text-[10px] text-gray-400">Minimum 8 characters.</p>
                        </div>

                        <div>
                            <label className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2">Confirm Password</label>
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="w-full bg-gray-50 border border-gray-200 p-3 outline-none focus:border-black transition-colors font-mono"
                                required
                            />
                        </div>

                        {error && (
                            <div className="text-red-500 text-xs uppercase font-bold tracking-wide text-center">
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-black text-white py-3 font-bold uppercase tracking-widest hover:bg-gray-800 transition-colors disabled:opacity-50"
                        >
                            {loading ? 'Initializing...' : 'Create Account'}
                        </button>
                    </form>
                </div>

                <div className="mt-8 text-center">
                    <a href="/creator/login" className="text-gray-400 text-xs uppercase tracking-widest hover:text-black hover:underline underline-offset-4">
                        Already set up? Login here
                    </a>
                </div>
            </div>
        </div>
    );
};

export default CreatorSetup;
